import script from "./gbnthome.vue?vue&type=script&setup=true&lang=js"
export * from "./gbnthome.vue?vue&type=script&setup=true&lang=js"

import "./gbnthome.vue?vue&type=style&index=0&id=261ed358&lang=less&scoped=true"
script.__scopeId = "data-v-261ed358"

export default script